import classnames from 'classnames';

export const cn = (...args: (string | Record<string, any>)[]) => {
    return classnames(args);
};
